/** Spoken structure shared with the native reader through vectors/speech.json. */
export const SPEECH_BLOCKS = "p, h1, h2, h3, h4, h5, h6, li, blockquote, dt, dd";
export const SPEECH_SKIP = "figure, figcaption, table, pre, code, aside, nav, .note, .card";
export const SPEECHIFY_MODEL = "simba-3.5";

/** Browser DOM adapter for the same outermost-block rule as Android's Jsoup adapter. */
export function spokenBlocks(root: ParentNode): { element: Element; text: string }[] {
  return [...root.querySelectorAll(SPEECH_BLOCKS)].filter(el => !el.parentElement?.closest(`${SPEECH_BLOCKS}, ${SPEECH_SKIP}`)).flatMap(element => {
    const copy = element.cloneNode(true) as Element;
    for (const br of copy.querySelectorAll("br")) br.replaceWith(" ");
    for (const block of copy.querySelectorAll("p, div, li, h1, h2, h3, h4, h5, h6, blockquote, dt, dd")) { block.prepend(" "); block.append(" "); }
    const text = copy.textContent?.replace(/\s+/g, " ").trim() ?? "";
    return text ? [{ element, text }] : [];
  });
}

/** Pack whole sentences where possible; every request stays below the provider limit. */
export function speechChunks(text: string, max = 1800): string[] {
  if (max < 1) throw new Error("Speech chunk size must be positive");
  if (text.length <= max) return [text];
  const sentences = typeof Intl.Segmenter === "function"
    ? [...new Intl.Segmenter(undefined, { granularity: "sentence" }).segment(text)].map(s => s.segment.trim()).filter(Boolean)
    : text.split(/(?<=[.!?])\s+/).map(s => s.trim()).filter(Boolean);
  const out: string[] = []; let now = "";
  for (const sentence of sentences) for (let i = 0; i < sentence.length; i += max) {
    const part = sentence.slice(i, i + max);
    if (now && now.length + 1 + part.length > max) { out.push(now); now = ""; }
    now += (now ? " " : "") + part;
  }
  if (now) out.push(now);
  return out;
}
